import { render } from "./start-message.vue?vue&type=template&id=155525c8"
import script from "./start-message.vue?vue&type=script&lang=js"
export * from "./start-message.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MAMP\\htdocs\\vetpartners\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/vacancies/listing/start-message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "155525c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('155525c8', __exports__)) {
    console.log('reload')
    api.reload('155525c8', __exports__)
  }
  
  module.hot.accept("./start-message.vue?vue&type=template&id=155525c8", () => {
    console.log('re-render')
    api.rerender('155525c8', render)
  })

}


export default __exports__